import { Injectable } from '@angular/core';
import { Http, Response, Headers, ResponseContentType } from '@angular/http';

import "rxjs/add/operator/map"
import { Observable } from 'rxjs/Observable';
import { Packagesponsor } from '../entity/prospect';
import { AppSettings } from './app.setting';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Client } from '../entity/exhibitor';



@Injectable()
export class PackagesponsorService {
 
    private baseUrl: string = environment.restApi + 'packagesponsor';
    private packageUrlERP = `${environment.restApiERP}participants`;
    notesBooks: Packagesponsor[];

    constructor(private http: Http,private httpClient: HttpClient) {

    }

    get(id: number): Observable<Packagesponsor> {
        let pavi$ = this.http
            .get(this.baseUrl + '/' + id, { headers: this.getHeaders() })
            .map(mapPackagesponsor);


        return pavi$;
    }
      getByProspect(idProspect: number): Observable<Packagesponsor> {
        
        return   this.httpClient.get<Packagesponsor>(this.baseUrl + '/getByProspect/' + idProspect);

      }
    
    remove(id: Number): Observable<Response> {
        return this.http.delete(`${this.baseUrl}/` + id)
    }
    getAll(): Observable<Packagesponsor[]> {
        let packagesponsor$ = this.http
            .get(this.baseUrl, { headers: this.getHeaders() })
            .map(mapPackagesponsors);
        return packagesponsor$;
    }


    private getHeaders() {
        let headers = new Headers();
        headers.append('Accept', 'application/json');
        let token = localStorage.getItem('token');
         headers.append('x-access-token',token);

        headers.append('Content-Type', 'application/json');
        return headers;
    }
    create(packagesponsor: Packagesponsor): Observable<Response> {
        return this.http.post(`${this.baseUrl}`, JSON.stringify(packagesponsor), { headers: this.getHeaders() });
    }
    save(packagesponsor: Packagesponsor): Observable<Response> {

        return this.http.put(`${this.baseUrl}/` + packagesponsor.id, JSON.stringify(packagesponsor), { headers: this.getHeaders() });

    }
    printContract(packageSponsor: Packagesponsor ,isSpeaker:boolean): any {
        return this.httpClient.get(this.baseUrl + '/printContract/'+isSpeaker+"/" +  packageSponsor.id, { responseType: "blob"} ) 
    }




      confirmPackageClient(prospectId: number, client: Client) {
 

    this.getByProspect(prospectId).subscribe(result=>{
    return this.httpClient
    .put<Packagesponsor>(this.baseUrl+`/confirmer`, result,httpOptions   ) ;
  }

  )
 
   
    }


    private getHeaders1() {
        const headers = new Headers();
        headers.append('Accept', 'application/pdf');
        headers.append('Content-Type', 'application/pdf');
        return headers;
      }
      

}
const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

function mapPackagesponsor(response: Response): Packagesponsor {
    return toPackagesponsor(response.json());
}
function mapPackagesponsors(response: Response): Packagesponsor[] {
    return response.json().map(toPackagesponsor);
} function toPackagesponsor(r: any): Packagesponsor {
    return r;
}

